import React from 'react'
import { Columns, Column } from 'react-flex-columns'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { withAppContext } from '../../utils/AppContext'
import Card from './Card'
import InputToggle from '../InputToggle'
import styles from '../../scss/ui/card.scss'

const FilterCard = ({ appContext }) => (
    <Card title="Include Which Houses?">
        <Columns gutterSize={1} className={cx(styles.center, styles.filterCardLabel)}>
            <Column className="owl left-content">
                <div className="right-content horizontal-owl-medium">
                    <span className="rangeLabel">NO</span>
                    <span className="rangeLabel">YES</span>
                </div>
                <div className="horizontal-owl vertical-middle">
                    <h3>Targaryen</h3>
                    <InputToggle
                        value={appContext.scoreCalculator.getData('switchWeights').targaryen ? 1 : 0}
                        onChange={
                            value => appContext.scoreCalculator.onUpdateCategory('targaryen', value, 'switchWeights')
                        }
                    />
                </div>
                <div className="horizontal-owl vertical-middle">
                    <h3 className="title">Stark</h3>
                    <InputToggle
                        value={appContext.scoreCalculator.getData('switchWeights').stark ? 1 : 0}
                        onChange={value => appContext.scoreCalculator.onUpdateCategory('stark', value, 'switchWeights')}
                    />
                </div>
                <div className="horizontal-owl vertical-middle">
                    <h3 className="title">Lannister</h3>
                    <InputToggle
                        value={appContext.scoreCalculator.getData('switchWeights').lannister ? 1 : 0}
                        onChange={
                            value => appContext.scoreCalculator.onUpdateCategory('lannister', value, 'switchWeights')
                        }
                    />
                </div>
                <div className="horizontal-owl vertical-middle">
                    <h3 className="title">Martell</h3>
                    <InputToggle
                        value={appContext.scoreCalculator.getData('switchWeights').martell ? 1 : 0}
                        onChange={
                            value => appContext.scoreCalculator.onUpdateCategory('martell', value, 'switchWeights')
                        }
                    />
                </div>
                <div className="horizontal-owl vertical-middle">
                    <h3 className="title">Baratheon</h3>
                    <InputToggle
                        value={appContext.scoreCalculator.getData('switchWeights').baratheon ? 1 : 0}
                        onChange={
                            value => appContext.scoreCalculator.onUpdateCategory('baratheon', value, 'switchWeights')
                        }
                    />
                </div>
            </Column>
            <Column className="owl left-content">
                <div className="right-content horizontal-owl-medium">
                    <span className="rangeLabel">NO</span>
                    <span className="rangeLabel">YES</span>
                </div>
                <div className="horizontal-owl vertical-middle">
                    <h3 className="title">Arryn</h3>
                    <InputToggle
                        value={appContext.scoreCalculator.getData('switchWeights').arryn ? 1 : 0}
                        onChange={value => appContext.scoreCalculator.onUpdateCategory('arryn', value, 'switchWeights')}
                    />
                </div>
                <div className="horizontal-owl vertical-middle">
                    <h3 className="title">Tully</h3>
                    <InputToggle
                        value={appContext.scoreCalculator.getData('switchWeights').tully ? 1 : 0}
                        onChange={value => appContext.scoreCalculator.onUpdateCategory('tully', value, 'switchWeights')}
                    />
                </div>
                <div className="horizontal-owl vertical-middle">
                    <h3 className="title">Tyrell</h3>
                    <InputToggle
                        value={appContext.scoreCalculator.getData('switchWeights').tyrell ? 1 : 0}
                        onChange={
                            value => appContext.scoreCalculator.onUpdateCategory('tyrell', value, 'switchWeights')
                        }
                    />
                </div>
                <div className="horizontal-owl vertical-middle">
                    <h3 className="title">Greyjoy</h3>
                    <InputToggle
                        value={appContext.scoreCalculator.getData('switchWeights').greyjoy ? 1 : 0}
                        onChange={
                            value => appContext.scoreCalculator.onUpdateCategory('greyjoy', value, 'switchWeights')
                        }
                    />
                </div>
                <div className="horizontal-owl vertical-middle">
                    <h3 className="title">Other</h3>
                    <InputToggle
                        value={appContext.scoreCalculator.getData('switchWeights').other ? 1 : 0}
                        onChange={value => appContext.scoreCalculator.onUpdateCategory('other', value, 'switchWeights')}
                    />
                </div>
            </Column>
        </Columns>
    </Card>
)

FilterCard.propTypes = {
    appContext: PropTypes.object.isRequired,
}

export default withAppContext(FilterCard)



// WEBPACK FOOTER //
// ./src/ui/CarouselCards/FilterCard.js